export default __webpack_public_path__ + "images/TV_Banner.png";